import './vehiculos.css';

const TIPOS_VEHICULO = ['Camión', 'Furgón', 'Pick-up', 'Moto', 'Auto', 'Utilitario'];

export default function VehiculoGeneralForm({ value, onChange, errors }) {
  const handleChange = (field, fieldValue) => {
    if (typeof onChange === 'function') {
      onChange({ ...value, [field]: fieldValue });
    }
  };

  return (
    <div className="form-section">
      <div className="form-field" data-error={Boolean(errors?.patente)}>
        <label htmlFor="vehiculo-patente">Dominio / Patente *</label>
        <input
          id="vehiculo-patente"
          name="patente"
          value={value.patente ?? ''}
          onChange={event => handleChange('patente', event.target.value.toUpperCase())}
          placeholder="ABC123"
          maxLength={7}
          autoComplete="off"
          required
        />
        {errors?.patente && <span className="field-error">{errors.patente}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.marca)}>
        <label htmlFor="vehiculo-marca">Marca</label>
        <input
          id="vehiculo-marca"
          name="marca"
          value={value.marca ?? ''}
          onChange={event => handleChange('marca', event.target.value)}
          placeholder="Mercedes Benz"
        />
        {errors?.marca && <span className="field-error">{errors.marca}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.modelo)}>
        <label htmlFor="vehiculo-modelo">Modelo</label>
        <input
          id="vehiculo-modelo"
          name="modelo"
          value={value.modelo ?? ''}
          onChange={event => handleChange('modelo', event.target.value)}
          placeholder="Actros 2545"
        />
        {errors?.modelo && <span className="field-error">{errors.modelo}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.anio)}>
        <label htmlFor="vehiculo-anio">Año</label>
        <input
          id="vehiculo-anio"
          name="anio"
          type="number"
          min="1960"
          max={new Date().getFullYear() + 1}
          value={value.anio ?? ''}
          onChange={event => handleChange('anio', event.target.value ? Number(event.target.value) : '')}
        />
        {errors?.anio && <span className="field-error">{errors.anio}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.tipo)}>
        <label htmlFor="vehiculo-tipo">Tipo de vehículo</label>
        <select
          id="vehiculo-tipo"
          name="tipo"
          value={value.tipo ?? ''}
          onChange={event => handleChange('tipo', event.target.value)}
        >
          <option value="">Seleccioná...</option>
          {TIPOS_VEHICULO.map(tipo => (
            <option key={tipo} value={tipo}>
              {tipo}
            </option>
          ))}
        </select>
        {errors?.tipo && <span className="field-error">{errors.tipo}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.chasis)}>
        <label htmlFor="vehiculo-chasis">N° de chasis</label>
        <input
          id="vehiculo-chasis"
          name="chasis"
          value={value.chasis ?? ''}
          onChange={event => handleChange('chasis', event.target.value)}
        />
        {errors?.chasis && <span className="field-error">{errors.chasis}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.motor)}>
        <label htmlFor="vehiculo-motor">N° de motor</label>
        <input
          id="vehiculo-motor"
          name="motor"
          value={value.motor ?? ''}
          onChange={event => handleChange('motor', event.target.value)}
        />
        {errors?.motor && <span className="field-error">{errors.motor}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.capacidadKg)}>
        <label htmlFor="vehiculo-capacidad">Capacidad (kg)</label>
        <input
          id="vehiculo-capacidad"
          name="capacidadKg"
          type="number"
          min="0"
          value={value.capacidadKg ?? ''}
          onChange={event => handleChange('capacidadKg', event.target.value ? Number(event.target.value) : '')}
        />
        {errors?.capacidadKg && <span className="field-error">{errors.capacidadKg}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.volumenM3)}>
        <label htmlFor="vehiculo-volumen">Volumen (m³)</label>
        <input
          id="vehiculo-volumen"
          name="volumenM3"
          type="number"
          min="0"
          step="0.01"
          value={value.volumenM3 ?? ''}
          onChange={event => handleChange('volumenM3', event.target.value ? Number(event.target.value) : '')}
        />
        {errors?.volumenM3 && <span className="field-error">{errors.volumenM3}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.odometro)}>
        <label htmlFor="vehiculo-odometro">Odómetro actual *</label>
        <input
          id="vehiculo-odometro"
          name="odometro"
          type="number"
          min="0"
          required
          value={value.odometro ?? ''}
          onChange={event => handleChange('odometro', event.target.value ? Number(event.target.value) : '')}
        />
        {errors?.odometro && <span className="field-error">{errors.odometro}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.choferAsignado)}>
        <label htmlFor="vehiculo-chofer">Chofer asignado</label>
        <input
          id="vehiculo-chofer"
          name="choferAsignado"
          value={value.choferAsignado ?? ''}
          onChange={event => handleChange('choferAsignado', event.target.value)}
          placeholder="Seleccioná un chofer"
        />
        {errors?.choferAsignado && <span className="field-error">{errors.choferAsignado}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.empresa)}>
        <label htmlFor="vehiculo-empresa">Empresa / Sucursal</label>
        <input
          id="vehiculo-empresa"
          name="empresa"
          value={value.empresa ?? ''}
          onChange={event => handleChange('empresa', event.target.value)}
          placeholder="Central"
        />
        {errors?.empresa && <span className="field-error">{errors.empresa}</span>}
      </div>
    </div>
  );
}
